import { render, staticRenderFns } from "./OptionForm.vue?vue&type=template&id=51a661b1"
import script from "./OptionForm.vue?vue&type=script&lang=ts"
export * from "./OptionForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports